import React from 'react';
import moment from 'moment';
import { Switch } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BackTop, Icon, Layout } from 'antd';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import './layout.css';
import UserMenu from './user-menu';
import { LangMenu } from './lang-menu';
import MainMenu from './main-menu';
import Logo from './logo';
import { withApollo } from 'react-apollo';
import { NotifyBtn } from './notifications/notify-popover';

const { Header, Content, Footer, Sider } = Layout;

class DashboardLayout extends React.Component {
  state = {
    collapsed: false,
  };

  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    return (
      <Layout className="dashboard">
        <Header>
          <Logo />
          <Icon
            className="trigger"
            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
            onClick={this.toggleCollapsed}
          />
          <UserMenu />
          <NotifyBtn client={this.props.client} />
          <LangMenu />
        </Header>

        <Layout style={{ marginTop: '54px' }}>
          <Sider collapsible trigger={null} collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
            <MainMenu />
            {this.props.extSiderCmp}
          </Sider>
          <Content
            style={{
              margin: '0 0px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {this.props.beforeContentCmp}
            <div className="page-content">
              <BreadcrumbsItem to="/dashboard" className="ant-breadcrumb-link">
                <Icon type="home" />
              </BreadcrumbsItem>
              <Switch>{this.props.children}</Switch>
            </div>
            <BackTop>
              <div className="ant-back-top-content">
                <Icon className="ant-back-top-icon" type="up" />
              </div>
            </BackTop>
          </Content>
        </Layout>
        <Footer>
          <FormattedMessage
            id="footer.copyright"
            defaultMessage="© {year} Conduster. All rights reserved"
            values={{ year: moment().utc().format('YYYY') }}
          />
        </Footer>
      </Layout>
    );
  }
}

export default withApollo(injectIntl(DashboardLayout));



// WEBPACK FOOTER //
// ./src/components/dashboard/layout/index.js